import React from 'react';
import FuelBasicForm from './FuelBasicForm';
import { useSelector, useDispatch } from 'react-redux';
import { viewSelector } from '../../features/fueladmin/fuelSlice';
import { initiateSetup, sensorIndexSelector, tankIndexSelector } from '../../features/fueladmin/fuelSlice';
import { Button, Typography, Divider } from '@mui/material';
import FuelAddSensorForm from './FuelAddSensorForm';
import FuelCalibrate from './FuelCalibrate';
import TankForm from './TankForm';
import TankMapSensors from './TankMapSensors';
import FuelEvent from './FuelEvent';
import FuelDeviceChange from './FuelDeviceChange';

const FuelRightColumn = ({ fuelSetup, assetId, assetData }) => {

    const dispatch = useDispatch();

    const view = useSelector(viewSelector);
    const sensorIndex = useSelector(sensorIndexSelector);
    const tankIndex = useSelector(tankIndexSelector);

    const initiate = () => {
        dispatch(initiateSetup(assetId));
    }


    return (
        <div>
            {
                view === 'nodata' &&
                <div>
                    <Button variant="text" size="large" onClick={() => initiate()}>Create Setup</Button>
                </div>
            }
            {
                view === 'basicDetails' && <FuelBasicForm assetId={assetId} assetData={assetData} />
            }
            {
                view === 'addSensor' && fuelSetup && fuelSetup.setupId && <FuelAddSensorForm view={view} fuelSetup={fuelSetup} assetId={assetId} sensorIndex={sensorIndex} />
            }
            {
                view === 'editSensor' && fuelSetup && fuelSetup.setupId && <FuelAddSensorForm view={view} fuelSetup={fuelSetup} assetId={assetId} sensorIndex={sensorIndex} />
            }
            {
                view === 'calibrateSensor' && fuelSetup && fuelSetup.setupId
                && fuelSetup.sensors[sensorIndex - 1].sensorId &&
                <FuelCalibrate fuelSetup={fuelSetup} assetId={assetId} sensorIndex={sensorIndex} />
            }
            {
                view === 'addTank' && fuelSetup && fuelSetup.setupId && <TankForm view={view} fuelSetup={fuelSetup} assetId={assetId} tankIndex={tankIndex} />
            }
            {
                view === 'editTank' && fuelSetup && fuelSetup.setupId && <TankForm view={view} fuelSetup={fuelSetup} assetId={assetId} tankIndex={tankIndex} />
            }
            {
                view === 'mapSensor' && fuelSetup && fuelSetup.setupId && <TankMapSensors view={view} fuelSetup={fuelSetup} assetId={assetId} tankIndex={tankIndex} />
            }
            {
                view === 'addEvent' && fuelSetup && fuelSetup.setupId && <FuelEvent view={view} fuelSetup={fuelSetup} assetId={assetId} />
            }
            {
                view === 'editEvent' && fuelSetup && fuelSetup.setupId && <FuelEvent view={view} fuelSetup={fuelSetup} assetId={assetId} />
            }
            {
                view === 'changeDevice' && fuelSetup && fuelSetup.setupId && <FuelDeviceChange view={view} fuelSetup={fuelSetup} assetId={assetId} />
            }
            {
                view === 'main' &&
                <div sx={{ m: 3 }}>
                    {
                        fuelSetup && fuelSetup.error && fuelSetup.error.length > 0 &&
                        <div>
                            <Typography variant="h6">Check the Following</Typography>
                            <Divider />
                            {
                                fuelSetup.error.map((e, i) =>
                                    <Typography variant="body1" key={i}>
                                        <span style={{ color: 'Crimson' }}>{e}</span>
                                    </Typography>
                                )
                            }
                        </div>
                    }
                    {
                        fuelSetup && fuelSetup.success &&
                        <div>
                            <Typography variant="h6">Looks Good</Typography>
                            <Divider />
                            <Typography variant="body1">
                                <span style={{ color: 'Green' }}>{fuelSetup.success}</span>
                            </Typography>
                        </div>
                    }
                </div>
            }

        </div>
    )
}

export default FuelRightColumn;